webpackJsonp([5356050244152032000],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/work-experience.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---work-experience-586c7e095e534a3909ec.js